export default {
    name: "DisambiguationModal",
    props: ['file'],
    computed: {},
    data() {
        return {};
    },
    methods: {
        selectDestinataire(dest) {
            if(dest != null) {
                this.file.destinataire.splice(0, this.file.destinataire.length, dest);
                if(dest.id) {
                    this.file.destinataire_id = dest.id
                }
            } else {
                this.file.destinataire.splice(0, this.file.destinataire.length, {mail: 'all'});
                this.file.destinataire_id = null;
            }
        },
    },
    filters: {
    },
    watch: {
    },
    mounted() {
        this.$refs['disambi'].show()
    }
};
